import React from 'react';
import './Cabecalho.css';

export default class Cabecalho extends React.Component {
  constructor(props) {
    super(props);
    this.default = {
      buttonList: [
        { titulo: "BUTTON 1", href: "#link1", action: null },
        { titulo: "BUTTON 2", href: "#link2", action: null },
        { titulo: "BUTTON 3", href: "#link3", action: null },
        { titulo: "BUTTON 4", href: "#link4", action: null },
        { titulo: "BUTTON 5", href: "#link5", action: null },
      ]
    };
  }

  link(btn) {
    if (btn.action == null) {
      return <li key={btn.titulo}><a href={btn.href}>{btn.titulo}</a></li>;
    } else {
      return <li key={btn.titulo}><a href={btn.href} onClick={btn.action}>{btn.titulo}</a></li>;
    }
  }

  render() {
    const buttonList = this.props.buttonList || this.default.buttonList;

    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <a className="navbar-brand" href="/"><img src={require('../../img/Quantum3.png')} width={30} height={30} alt="Quantum Trades" /></a>
          </div>
          <div className="collapse navbar-collapse" id="myNavbar">
            <ul className="nav navbar-nav navbar-right">
              {buttonList.map((btn) => this.link(btn))}
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
